module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACbSURBVHgB7dIxCkIxDAbgP30d3Oyk6zuCIM5ewXcET+BVPIJXcRfpDXQVl4qbTxNRECoUXqFLh3xLyd+ELAGUKkVxMZ4uToC0KMDM6/v1uPvV9m8b9x0a61Cg6dlDVYVSoZvMV0K0Qb5wuxy61IdNtpuXF7Z7ZBLDZ6hqUU7T56oYNIsz83huQ/BhaNYiB0lLoGWUBIzgvq+q3ht8FScHVYd3jgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bars-filter-light.png
// module id = mqCc
// module chunks = 1